import { render } from "./GTDesigner.vue?vue&type=template&id=2a655b2e&scoped=true"
import script from "./GTDesigner.vue?vue&type=script&lang=js"
export * from "./GTDesigner.vue?vue&type=script&lang=js"

import "./GTDesigner.vue?vue&type=style&index=0&id=2a655b2e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a655b2e"]])

export default __exports__